/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I1_TextInputs */

const tr_kullanim_s18_i1_text = /** @type {(inputs: Kullanim_S18_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı Sözleşme'yi devredemez; Şirket devir hakkını saklı tutar.`)
};

const en_kullanim_s18_i1_text = /** @type {(inputs: Kullanim_S18_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User may not assign the Agreement; the Company reserves the right of assignment.`)
};

const de_kullanim_s18_i1_text = /** @type {(inputs: Kullanim_S18_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer kann den Vertrag nicht übertragen; das Unternehmen behält sich das Übertragungsrecht vor.`)
};

const ru_kullanim_s18_i1_text = /** @type {(inputs: Kullanim_S18_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь не может передавать Договор; Компания сохраняет за собой право передачи.`)
};

/**
* | output |
* | --- |
* | "The User may not assign the Agreement; the Company reserves the right of assignment." |
*
* @param {Kullanim_S18_I1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i1_text = /** @type {((inputs?: Kullanim_S18_I1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i1_text(inputs)
	if (locale === "de") return de_kullanim_s18_i1_text(inputs)
	if (locale === "ru") return ru_kullanim_s18_i1_text(inputs)
	return tr_kullanim_s18_i1_text(inputs)
});